import {Constructor} from "../../global/constructor";
import CodeMirrorEditor from "./codeMirrorEditor";


export default function CodeMirrorAble<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    editor: CodeMirrorEditor;
  }
}